import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { BackLink } from "@/components/BackLink";
import { LegalDocView } from "@/components/legal/LegalDocView";
import { Skeleton } from "@/components/ui/skeleton";
import { EmptyState } from "@/components/EmptyState";
import { api } from "@/lib/api";
import { usePageMeta } from "@/lib/seo";

/* The resolved Standard Auction Terms for one event (Legal Engine).
   Published events serve the immutable snapshot pinned at publish time. */
export default function AuctionTermsPage() {
  /* WS6/WS13: los términos por subasta son casi idénticos entre sí →
     noindex individual; el documento legal corporativo es el indexable. */
  usePageMeta({ robots: "noindex, follow" });
  const { eventId } = useParams();
  const { t, i18n } = useTranslation();
  const [doc, setDoc] = useState(undefined);

  useEffect(() => {
    setDoc(undefined);
    api
      .get(`/legal/events/${eventId}/auction-terms`, { params: { locale: i18n.resolvedLanguage } })
      .then(({ data }) => setDoc(data))
      .catch(() => setDoc(null));
  }, [eventId, i18n.resolvedLanguage]);

  if (doc === undefined) {
    return (
      <div className="max-w-6xl mx-auto px-6 lg:px-12 py-16 space-y-6" data-testid="auction-terms-skeleton">
        <Skeleton className="h-10 w-2/3 rounded-xl" />
        <Skeleton className="h-72 w-full rounded-3xl" />
      </div>
    );
  }
  if (doc === null) {
    return (
      <div className="max-w-3xl mx-auto px-6 py-24">
        <EmptyState title={t("legal.notFoundTitle")} description={t("legal.notFoundBody")} />
      </div>
    );
  }
  return (
    <div data-testid="auction-terms-page">
      <div className="max-w-6xl mx-auto px-6 lg:px-12 pt-8">
        <BackLink />
      </div>
      <LegalDocView doc={doc} />
    </div>
  );
}
